export default __webpack_public_path__ + "img/twitter.d92557fbeeb7b311689648276091e786.svg";